import { render, staticRenderFns } from "./ActivationBriefProductsItem.vue?vue&type=template&id=21c5d899&scoped=true&"
import script from "./ActivationBriefProductsItem.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefProductsItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefProductsItem.vue?vue&type=style&index=0&id=21c5d899&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c5d899",
  null
  
)

export default component.exports